export default __webpack_public_path__ + "static/media/logo.4a32e0bc.svg";